import { render, staticRenderFns } from "./SelectBox.vue?vue&type=template&id=b8231c0e&scoped=true"
import script from "./SelectBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectBox.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SelectBox.vue?vue&type=style&index=0&id=b8231c0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8231c0e",
  null
  
)

export default component.exports